import { render } from "./TabBar.vue?vue&type=template&id=d5d1e11c"
import script from "./TabBar.vue?vue&type=script&lang=js"
export * from "./TabBar.vue?vue&type=script&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=d5d1e11c&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__